import { Skeleton, Stack, Typography, useTheme } from "@mui/material";

export function KeyMetric({
  name,
  value,
  loading,
}: {
  name: string;
  value: number | string | undefined;
  loading: boolean;
}) {
  const theme = useTheme();
  return (
    <Stack
      direction="column"
      width="100%"
      py={theme.spacing(0.5)}
      px={theme.spacing(2)}
      borderRadius={theme.spacing(1)}
      height={theme.spacing(7.5)}
    >
      <Typography variant="caption" color={theme.palette.text.secondary}>
        {name}
      </Typography>
      <Typography variant="body2" color={theme.palette.text.primary}>
        {loading ? <Skeleton variant="text" width={50} /> : value ?? 0}
      </Typography>
    </Stack>
  );
}
